import React, { useState } from "react";
import Header from "../Layouts/Header";
import { AppSidebar } from "../Layouts/Sidebar";

export const LandingPage = () => {
    const [selectedOption, setSelectedOption] = useState("Welcome To Exdion");

    return (
        <div >
            <div className="main-container">
                {/* Header Container */}
                <div className="header-container">
                    <Header selectedOption={selectedOption} />
                </div>
                <div className="app-container">
                    {/* Sidebar Container */}
                    <div >
                        <AppSidebar />
                    </div>
                </div>
            </div>
        </div>
    );
}


